import Blogs from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ManageBlog from "../../../../../components/sections/admin/Blog/ManageBlog";
import BlogCategory from "../BlogCategory";
// import BlogComment from "../BlogComment";
import BlogTags from "../BlogTags";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-blog",
    path: "/admin/posts",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/post-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/post-tags",
  },
  // {
  //   label: "Comments",
  //   icon: "fa-regular fa-comments",
  //   path: "/admin/post-comments",
  // },
];

export const blogRoutes = () => [
  {
    path: "/admin/posts",
    component: () => (
      <TabsNavigation title="Posts Management" tabRoutes={tabRoutes}>
        <Blogs />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Posts Management",
  },
  {
    path: "/admin/post-categories",
    component: () => (
      <TabsNavigation title="Posts Management" tabRoutes={tabRoutes}>
        <BlogCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Posts Management",
  },
  {
    path: "/admin/post-tags",
    component: () => (
      <TabsNavigation title="Posts Management" tabRoutes={tabRoutes}>
        <BlogTags />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Posts Management",
  },
  // {
  //   path: "/admin/post-comments",
  //   component: () => (
  //     <TabsNavigation title="Posts Management" tabRoutes={tabRoutes}>
  //       <BlogComment />
  //     </TabsNavigation>
  //   ),
  //   layout: "admin",
  //   routeType: "admin",
  //   title: "Posts Management",
  // },
  {
    path: "/admin/manage-blogs",
    component: ManageBlog,
    layout: "admin",
    routeType: "admin",
    title: "Manage Blogs",
  },
  {
    path: `/admin/manage-blogs/:id`,
    component: ManageBlog,
    layout: "admin",
    routeType: "admin",
    title: "Manage Blogs",
  },
];
